import styled, { keyframes } from 'styled-components';

export const PopupContainer = styled.div`
  background: #fff;
  padding: 20px 0px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  h4 {
    margin-bottom: 16px;
    padding-left: 12px;
    flex-grow: 0;
    margin: 0 0 8px;
    font-size: 20px;
    font-weight: bold;
    font-family: Montserrat;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #242424;
  }
  .seperator {
    width: 152px;
    height: 1px;
    flex-grow: 0;
    background-color: rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
    margin-left: 12px;
  }
`;

export const PopupRadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 20px 0;
  opacity: ${(props) => (props.isOos ? '0.4' : '1')};
  cursor: ${(props) => (props.isOos ? 'disable' : '')};
  .img {
    width: 70px;
    height: 70px;
    background: #eee;
  }
  .oos {
    font-size: 12px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    opacity: 1;
    margin-top: 4px;
  }
  input {
    width: 24px;
    height: 24px;
    &:checked {
      accent-color: #ef4e5e;
    }
  }
  p {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 4px;
  }
  span {
    font-size: 12px;
    display: block;
    font-weight: 500;
    opacity: 0.5;
  }
`;

export const BundleContainer = styled.div`
    position: relative;

    .packContainer {
        flex-grow: 0;
        margin: 16px 0 16px 0;
        padding: 13px 18px 12px 12px;
        border-radius: 10px;
        border: solid 1px #cbcbcb;
        display: flex;
        background-color: #fff;
        justify-content: space-between;
        // justify-content: center;
        align-items: center;
    }

    .bestSeller {
        position: absolute;
        top: 0;
        left: 0;
        width: 84px;
        padding: 2px 4px 2px 16px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.13);
        background-color: #fcecdf;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        justify-content: center;
        align-items: center;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #805020;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        z-index: 1;
    }

    p {
        flex-grow: 0;
        margin: 0px 25px 0px 0px;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
    }

    span {
        flex-grow: 0;
        margin: 0 0 0 0px;
        font-family: Montserrat;
        font-size: 10px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
        opacity: 0.54;
    }

    .priceItems {
        align-items: center;
    }

    .price {
        flex-grow: 0;
        margin: 4px 71px 2px 0px;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: rgba(0, 0, 0, 0.87);
    }

    .strikePriceContainer {
        display: flex;
    }

    .strikePrice {
        flex-grow: 0;
        margin: 0px 2px 0 0px;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        text-decoration: line-through;
        color: rgba(0, 0, 0, 0.38);
    }

    .discount {
        flex-grow: 0;
        margin: 0px 28px 0 4px;
        font-family: Montserrat;
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #63b0a8;
    }

    .buyNow {
        width: 77px;
        height: 34px;
        flex-grow: 0;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        margin: 0px 0 9px 0px;
        padding: 11px 0px 10px 0px;
        border-radius: 4px;
        background-color: #ef4e5e;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;

        &:disabled {
            background: rgba(252, 147, 158, 0.73);
            pointer-events: none;
        }

    }

    .image {
        width: 100px;
        height: 100px;
        flex-grow: 0;
        margin: 0 20px 3px 12px;
        border-radius: 8px;
    }

    @media (max-width: 720px) {
        flex-basis: "33.33%");
    }
    @media (min-width: 768px) {
        width: "24.8%";
    }
    margin-right: "6px";

    .extraPadding {
        padding: 10px;
    }

    // position: relative;
    z-index: 2;

`;

export const PowerContentContainer = styled.div`
  overflow: hidden;
`;

export const GradientSection = styled.div`
  border-radius: 6px;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #fff);
  width: 100%;
  height: 8px;
`;

export const SwipeImg = styled.img`
  margin: 7px 0 0 5px;
  transform: scaleX(-1);
  width: 40px;
`;

export const SwipeContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 65%;
  rotate: 180deg;
  left: calc(${(props) => 100 - props.leftOffset}% - 160px);
  animation: swipe 2s ease-in-out;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  z-index: 40;
  @keyframes swipe {
    from {
      width: 10px;
      opacity: 1;
    }
    to {
      width: 120px;
      opacity: 0;
    }
  }
`;

export const ActionButton = styled.button`
  background: #0000008c;
  color: #fff;
  font-size: 12px;
  font-family: Montserrat;
  position: absolute;
  top: 0;
  min-width: 80px;
  outline: none;
  border: none;
  letter-spacing: 0.5px;
  padding: 10px;
  left: ${(props) => props.left && props.left};
  right: ${(props) => props.right && props.right};
`;

export const BeforeAndAfterContainer = styled.div`
    margin-top: 10px;
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    background: ${(props) => props.tabThemeColor || '#498A5B'};
    padding: 20px 10px;
    user-select: none
    cursor: default;
    @media (max-width: 768px) {
        max-width: 460px;
    }

    .beforeAndAfter {
        background: #fff;
        elevation: 1;
        border-radius: 10px;
        padding: 20px 10px;
        display: grid;
        grid-template-rows: 1fr;
        grid-row-gap: 20px;
    }

    .beforeAfterContainer {

    }

    @media (min-width: 768px) {
        background: transparent;
        max-width: 1260px;
        .beforeAndAfter {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 20px;
        }
    }

    .title {
        margin: 0 0 12px 0;
        opacity: 0.87;
        font-family: Montserrat;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #000;
    }

    .dayTransformations {
        margin-bottom: -12px;
        padding: 16px 18px 36.5px 24px;
        border-radius: 10px;
        background-color: ${(props) => props.tabThemeSecondaryColor || '#498A5B'};
        opacity: 0.8;
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .dayText {
        margin: 0 0 11.5px 80px;
        opacity: 0.87;
        height: 28px;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000;
    }

    .counter-container {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        margin: 0 0 0 4px;
        border: none;

        img {
            width: 55px;
            height: 55px;
            position: absolute;
        }

        .number {
            font-family: Montserrat;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: ${(props) => props.tabThemeColor || '#498A5B'};
            z-index: 1;
        }

        .text {
            opacity: 0.87;
            font-family: Montserrat;
            font-size: 9px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 0.54px;
            text-align: left;
            color: #575757;
            z-index: 1;
        }
    }

    .counter-container::before {
        content: "";
        position: absolute;
        top: -5px; /* Adjust as needed for tick size */
        left: -5px; /* Adjust as needed for tick size */
        width: calc(100% + 10px); /* Adjust as needed for tick size */
        height: calc(100% + 10px); /* Adjust as needed for tick size */
        border-radius: 50%;
        background: conic-gradient(
                from 90deg,
                #559567 0deg,
                #559567 360deg
        ); /* Green ring */
        -webkit-mask: radial-gradient(
                circle,
                white 1px
        ); /* Creates the ticks */
        mask: radial-gradient(circle, white 1px); /* Creates the ticks */
        z-index: -1;
    }

    .footerContainer {
        display: flex; /* Use flexbox for horizontal layout */
        overflow: hidden; /* Hide any content that overflows the rounded corners */
        margin-top: -2px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .day-box {
        background-color: ${(props) => props.tabThemeColor || '#498A5B'};
        color: #e9f1eb;
        padding: 10px 20px;
        text-align: center;
        flex: 1;
        font-weight: bold;
        font-size: 14px;
        box-sizing: border-box;
    }

    .day-box-selected {
        color: #e9ea36;
    }

    .day-box + .day-box {
        border-left: 2px solid #e9ea36;
    }

    .curvContainer {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        overflow: hidden;
    }

    @media (min-width: 768px) {
        .research {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .research-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        max-width: 800px;
        margin: 0 auto;
        @media (min-width: 768px) {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            max-width: 800px;
            margin: 0 auto;
        }
    }

    .result {
        text-align: center;
        margin-bottom: 20px;
        width: 50%;
        @media (min-width: 768px) {
            display: grid;
            width: 100%;
            justify-content: center;
            grid-template-columns: 3fr 5fr;
            align-items: center;
            margin: 20px 0;
        }
    }

    .circle-container {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto 10px;
        @media (min-width: 768px) {
            width: 120px;
        }
    }

    .circle {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        corner-radius: 30px;
        // border: 8px solid ${(props) => props.tabThemeColor || '#498A5B'};
        position: absolute;
        box-sizing: border-box;
        // background: radial-gradient(closest-side 80%, transparent 80% 100%),
        //     conic-gradient(#559567 90%, white 0);
        background: radial-gradient(
                closest-side,
                white 79%,
                transparent 80% 100%
        ),
        conic-gradient(#559567 75%, #daf4e1 0);
        rotate: 180deg;
    }

    .fill {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
        height: 50%;
        border-radius: 50% 50% 0 0;
        background-color: #d0f0d0;
        border-top: 8px solid #d0f0d0;
        box-sizing: border-box;
        transform: translateX(-50%) rotate(-108deg);
    }

    .percent {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        opacity: 0.87;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: ${(props) => props.tabThemeColor || '#498A5B'};
        @media (min-width: 768px) {
            font-size: 24px;
            margin-top: 10px;
        }
    }

    .description {
        font-size: 0.9em;
        color: #555;
        line-height: 1.4;
        margin: 11.9px 17px 21px 9px;
        opacity: 0.87;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.42;
        letter-spacing: normal;
        text-align: center;
        color: #212121;
        @media (min-width: 768px) {
            font-size: 1.23em;
            text-align: left;
            margin: 0;
        }
    }

    .study-note {
        margin: 4px 7px 0;
        opacity: 0.87;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #7e7e7e;
        @media (min-width: 768px) {
            font-size: 0.9em;
            text-align: center;
        }
    }
`;

// export const ProgressBar = styled.div`
//     width: 100px;
//     height: 100px;
//     border-radius: 100%;
//     background: radial-gradient(closest-side, white 79%, transparent 80% 100%),
//         conic-gradient(#50a060 ${(props) => props.progress}%, #daf4e1 0);
//     animation: progress 5s 1 forwards;
//     overflow: hidden;
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     rotate: 180deg;
// `;

const createProgressAnimation = (progress, tabThemeColor, tabThemeSecondaryColor) => keyframes`
  from {
    background: radial-gradient(closest-side, white 80%, transparent 80% 100%),
        conic-gradient(${tabThemeColor || '#498a5b'} 0%,(${tabThemeSecondaryColor || '#daf4e1'}) 0);
  }
  to {
    background: radial-gradient(closest-side, white 75%, transparent 80% 100%),
        conic-gradient(${tabThemeColor || '#498a5b'} ${progress}%, ${tabThemeSecondaryColor || '#daf4e1'} 0);
  }
`;

export const ProgressBar = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  transition: stroke-dashoffset 2s ease-in-out;
  animation: ${(props) => createProgressAnimation(props.progress, props.tabThemeColor, props.tabThemeSecondaryColor)} 2s
    ease-in-out forwards;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  rotate: 180deg;
  @media (min-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

export const BeforAfterMain = styled.div`
  width: 100%;
  position: relative;
  aspect-ratio: 16/9;

  input {
    position: absolute;
    -webkit-appearance: none;
    top: 0;
    appearance: none;
    width: 100%;
    z-index: 50;
    height: 0;
    background: trensparent;
    color: transparent;
    outline: none;
    margin: 0px;

    ::-webkit-slider-thumb {
      appearance: none;
      transition: all 0.5s ease-in-out !important;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 60px;
      height: 40vh;
      transition: all 0.5s ease-in-out !important;
      background: rgba(255, 255, 255, 0);
      opacity: 0;

      @media (min-width: 768px) {
        cursor: pointer;
      }
    }
  }
`;
export const AfterImageContainer = styled.div`
  background: url(${(props) => props.bgImage});
  position: absolute;
  top: 0;
  left: 0;
  height: 25vh;
  width: 100%;
  height: 100%;
  color: #000;
  background-size: cover;
  background-size: ${(props) => props.bgImageWidth} 100%;
  transition: width 1s ease-in-out;
  z-index: 20;
  -webkit-filter: blur(5px) brightness(0.9);
  -moz-filter: blur(3px) brightness(0.9);
  -o-filter: blur(3px) brightness(0.9);
  -ms-filter: blur(3px) brightness(0.9);
  filter: blur(3px) brightness(0.9);
`;
export const BeforeImageContainer = styled.div`
  width: ${(props) => props.defaultWidth}%;
  background: url(${(props) => props.bgImage});
  position: absolute;
  top: 0;
  left: 0;
  height: 25vh;
  background-size: ${(props) => props.bgImageWidth} 100%;
  height: 100%;
  transition: width 500ms ease-in-out;
  background-size: cover;
  z-index: 30;
  overflow: hidden;

  &.noTransition {
    transition: none;
  }
`;
export const ResizeButtons = styled.div`
  width: min-content;
  position: absolute;
  top: calc(50% - 20px);
  margin-left: -10px;
  z-index: 90;
  left: calc(${(props) => props.defaultWidth}% - 20px);
  user-select: none;
  transition: left 500ms ease-in-out;
  pointer-events: none;

  &.noTransition {
    transition: none;
  }

  &:after {
    content: '';
    width: 6px;
    position: absolute;
    height: calc(20vh - 10px);
    background: white;
    left: calc(50% - 3px);
    top: 92%;
  }

  &:before {
    content: '';
    width: 6px;
    position: absolute;
    height: calc(20vh - 10px);
    background: white;
    bottom: 100%;
    left: calc(50% - 3px);
  }

  .sliderImage {
    width: 66px;
    height: 56px;
  }
`;
export const ToolTip = styled.div`
  position: absolute;
  top: 43%;
  left: calc(${(props) => props.defaultWidth}%);
  z-index: 40;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  rotate: 180deg;

  p {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    max-width: 70%;
    padding: 7px;
    rotate: 180deg;
  }

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-left: 19px solid rgba(0, 0, 0, 0.6);
    border-bottom: 8px solid transparent;
    position: absolute;
    display: block;
    top: 30%;
    right: 21%;
  }
`;

export const ComparisionTitle = styled.p`
  font-size: clamp(16px, 2vw, 20px);
  font-weight: 600;
  color: #000;
  opacity: 0.9;
`;

export const ComparisionDesc = styled.p`
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  margin: 15px 0 25px;
  opacity: 0.9;
`;
export const PPUText = styled.div`
  margin-left: auto;
  font-family: 'Montserrat';
  p {
    font-size: 13px;
    color: #6e6e6e;
    font-weight: 400;
  }
  b {
    font-size: 14px;
  }
`;

